



























import { Vue, Component } from 'vue-property-decorator';

@Component
export default class BudtenderScorecard extends Vue {
  calculateGrade() {
    const percentageGrade = (this.$store.getters.totalCorrectAnswers / this.totalQuestions()) * 100;
    return Math.round(percentageGrade);
  }

  totalQuestions(): number {
    return (
      this.$store.getters.totalCorrectAnswers
      + this.$store.getters.totalWrongAnswers
    );
  }
}
